import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from '@/mixins/packageTableMixins';
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD } from '@/libs/util';
import { building_list, device_file_fail_list } from '@/api/pests';
import ImageMap from '@/view/components/imageMap/imageMap';
export default {
  name: "addAppCustom",
  mixins: [packageTableMixins],
  data: function data() {
    var _ref;

    return _ref = {
      reduceheight: 160,
      columnsheader: [{
        align: 'center',
        title: '行号',
        minWidth: 80,
        key: 'sheet_id'
      }, {
        align: 'center',
        title: '失败原因',
        minWidth: 80,
        key: 'error_str'
      }],
      axis: [],
      //已存在坐标
      headers: {
        'Authorization': getToken()
      },
      extraData: {
        project_code: this.projectCode,
        cate_code: this.cate_code
      },
      imageSrc: null,
      floorListData: [],
      //楼层列表
      buildingListData: [],
      //平面图列表
      projectListData: [],
      //项目记录
      deviceTypeData: [],
      //设备分类
      devicePurposeData: [],
      //设备用途
      defaultList: [],
      maintainList: [],
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 3,
      BMap: null,
      position: {
        lng: 0,
        lat: 0
      },
      uploadList: [],
      refName: 'refName'
    }, _defineProperty(_ref, "headers", {
      Authorization: getToken()
    }), _defineProperty(_ref, "hasDisabled", true), _defineProperty(_ref, "fileName", 'image'), _defineProperty(_ref, "fileData", {
      client_id: ""
    }), _defineProperty(_ref, "format", ['xlsx']), _defineProperty(_ref, "visible", false), _defineProperty(_ref, "imgName", ''), _defineProperty(_ref, "uploadData", {
      client_id: null
    }), _defineProperty(_ref, "uploadHeaders", {
      "Authorization": getToken()
    }), _defineProperty(_ref, "proAttrFile", {}), _defineProperty(_ref, "formModel", {
      md5_file: null //设备名称

    }), _defineProperty(_ref, "topButtonList1", [{
      name: '刷新',
      icon: 'ios-refresh',
      type: 'primary',
      method: this.init
    }]), _defineProperty(_ref, "formRules", {
      md5_file: [{
        required: true,
        message: '导入文件不能为空',
        trigger: 'change'
      }]
    }), _defineProperty(_ref, "reqBase", {
      page: 1,
      page_size: 15
    }), _ref;
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {},
    id: {}
  },
  components: {
    ImageMap: ImageMap
  },
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.device_file_upload;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.device_file_upload;
      } else {
        result = config.baseUrl.alp + "" + pests.device_file_upload;
      }

      return result;
    }
  },
  methods: (_methods = {
    /**
     * 获取设置时的宽度高度
     */
    userWidthHeight: function userWidthHeight(width, height) {
      this.$set(this.formModel, 'enlarge_width', width);
      this.$set(this.formModel, 'enlarge_height', height);
    },

    /**
     * 获取楼层
     */
    getFloor: function getFloor(val, callback) {
      for (var i = 0; i < this.floorListData.length; i++) {
        var list = this.floorListData[i];

        if (val === list.floor_code) {
          this.imageSrc = list.file_url;
          break;
        }
      }

      if (callback) {
        callback();
      }
    },

    /**
     * 获取坐标
     */
    getAxis: function getAxis(axis) {
      this.$set(this.formModel, 'x_axis', axis.x);
      this.$set(this.formModel, 'y_axis', axis.y); // this.axis.splice(0,1,axis)
    },

    /**
     * 项目改变
     */
    changeProject: function changeProject(val, callback) {
      var _this = this;

      this.$set(this.formModel, 'building_code', null);
      this.$set(this.formModel, 'floor_code', null);
      building_list({
        page: 0,
        page_size: 0,
        project_code: val
      }).then(function (res) {
        if (res.result === 0) {
          _this.buildingListData = res.body.list || [];

          if (callback) {
            callback();
          }
        } else {}
      });
    },

    /**
     * 改变平面图
     */
    changeBuilding: function changeBuilding(val, callback) {
      // this.$set(this.formModel,'floor_code',null)
      for (var i = 0; i < this.buildingListData.length; i++) {
        var list = this.buildingListData[i];

        if (val === list.building_code) {
          this.imageSrc = list.file_url;
          break;
        }
      } // floor_list({page:0,page_size:15,building_code:val}).then(res=>{
      //   if(res.result===0){
      //     this.floorListData=res.body.list ||[]
      //     if(callback){
      //       callback()
      //     }
      //   }
      // })

    },
    handleView: function handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleMaxSize: function handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '请上传小于4M的图片'
      });
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      return true;
    },

    /**
     * 上传进度
     */
    handleProgess: function handleProgess(event, file, fileList) {},

    /**
     * 维保开始日期
     */
    startChange: function startChange(val) {
      this.$set(this.formModel, 'maintain_start', val);
    },

    /**
     * 合同开始日期
     */
    contractTimeChange: function contractTimeChange(arr) {
      this.$set(this.formModel, 'contract_start', arr[0]);
      this.$set(this.formModel, 'contract_end', arr[1]);
    },
    //检查图片的width和height
    checkImageWH: function checkImageWH(file, width, height) {
      var self = this._vm;
      return new Promise(function (resolve, reject) {
        var filereader = new FileReader();

        filereader.onload = function (e) {
          var src = e.target.result;
          var image = new Image();

          image.onload = function () {
            if (width && this.width != width) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleWidth') + width
              });
              reject();
              self.spinShow = false;
            } else if (height && this.height != height) {
              self.$Notice.error({
                title: self.$t('operationModule.uploadFileFormatTitleHeight') + height
              });
              reject();
              self.spinShow = false;
            } else {
              resolve();
            }
          };

          image.onerror = reject;
          image.src = src;
        };

        filereader.readAsDataURL(file);
      });
    },

    /**
     * 上传之前检查width,height
     */
    handleUploadImg: function handleUploadImg(file, width, height) {
      return this.checkImageWH(file, width, height);
    }
  }, _defineProperty(_methods, "handleRemove", function handleRemove(file, fileList, str) {
    this.$set(this.formModel, 'company_avatar', '');
    this.uploadList.splice(0);
  }), _defineProperty(_methods, "handleSuccess", function handleSuccess(res, file, str) {
    var vm = this; // this.uploadList.splice(0)

    if (res.result === 0) {
      //to do
      this.$set(this.formModel, 'md5_file', res.body.md5_file); // this.uploadList.push({
      //   status:'finished',
      //   url:res.body.file_path,
      //   name:file.name
      // })
    } else {
      //删除上传的对象
      this.$Message.error(res.errorMsg);
    }
  }), _defineProperty(_methods, "clientChange", function clientChange(val) {
    this.$set(this.fileData, 'client_id', val);
    this.hasDisabled = false;
  }), _defineProperty(_methods, "handleView", function handleView(name) {
    this.imgName = name;
    this.visible = true;
  }), _defineProperty(_methods, "handleFormatError", function handleFormatError(file) {
    this.$Notice.warning({
      title: '文件格式错误',
      desc: '请上传' + this.format.join(', ') + '类型文件'
    });
  }), _defineProperty(_methods, "init", function init() {
    var _this2 = this;

    this.tableLoading = true;
    device_file_fail_list(this.reqBase).then(function (res) {
      _this2.tableLoading = false;
      _this2.tableDataList = [];

      if (res.result === 0) {
        _this2.tableDataList = res.body.list || [];
        _this2.getPageTotal = res.body.total;
      } else {
        _this2.tableDataList = [];
        _this2.getPageTotal = 0;

        _this2.$Message.error(res.errorMsg);
      }
    });
  }), _methods),
  mounted: function mounted() {
    this.$set(this.reqBase, 'project_code', this.project_code);
    this.$set(this.reqBase, 'cate_code', this.cate_code);
  },
  created: function created() {
    this.$set(this.reqBase, 'id', this.id);
    this.init();
  }
};